// import React, { Component } from 'react'
// import Cookies from 'universal-cookie'
// import SelectList from '../components/createQuestionSubComponents/dropdownSelect'
// import Header from '../components/dashboardSubComponents/header'
// import SideBar from '../components/dashboardSubComponents/sideBarNav'
// import { Loader } from 'react-overlay-loader'
// import QuestionTable from '../components/questionListSubComponents/questionTable'
// import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
// import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
// import { url, logout } from '../components/helper'

// class Questions extends Component {
//     constructor(props) {
//         super(props)
//         this.state = {
//             superuser: '',
//             organization_admin: '',
//             branch_admin: '',
//             branch_user: '',
//             options_organization: [],
//             options_branch: [],
//             options_customers: '',
//             options_sections: [],
//             total_records: 0,
//             questions: [],
//             organization: null,
//             branch: null,
//             customer: '',
//             loading: true,
//             tableHidden: true,
//             tableLoading: false,
//             activePage: 1,
//             message_title: '',
//             message_body: '',
//             error_modal_open: false,
//             fetch_btn_disabled: true,
//             page_size: 20,
//         }
//         this.handleOrganizationSelect = this.handleOrganizationSelect.bind(this)
//         handleBranchSelect = handleBranchSelect.bind(this)
//         handleCustomerSelect = handleCustomerSelect.bind(this)
//         fetchQuestions = fetchQuestions.bind(this)
//         nextPage = nextPage.bind(this)
//         createQuestionClickHandle =
//             createQuestionClickHandle.bind(this)
//         closeErrorModal = closeErrorModal.bind(this)
//         this.enable_btn = this.enable_btn.bind(this)
//         handlePageSizeChange = handlePageSizeChange.bind(this)
//         fetchQuestions_with_page_size.bind(this)
//     }

//     componentWillMount = () => {
//         const cookies = new Cookies()
//         var loginStatus = cookies.get('loggedIn')
//         //(loginStatus)
//         if (loginStatus === undefined) {
//             window.location = '/login'
//         } else {
//             this.setState({ current_section: 1 })
//         }
//         var superuser = cookies.get('superuser')
//         var organization_admin = cookies.get('organization-admin')
//         var branch_admin = cookies.get('branch-admin')
//         var branch_user = cookies.get('branch-user')
//         this.setState({
//             superuser: superuser,
//             organization_admin: organization_admin,
//             branch_admin: branch_admin,
//             branch_user: branch_user,
//         })
//         var http = new XMLHttpRequest()
//         var dashboar_ref = this
//         var user_id = cookies.get('user_id')
//         var token = cookies.get('token')
//         //('Token ' + token)
//         if (branch_admin === 'true') {
//             http.open(
//                 'GET',
//                 url + '/api/questions/wizard/branch?user_id=' + user_id,
//                 true
//             )
//         } else {
//             http.open(
//                 'GET',
//                 url + '/api/questions/wizard/organisation?user_id=' + user_id,
//                 true
//             )
//         }

//         http.setRequestHeader('Authorization', 'Token ' + token)
//         http.send()
//         http.onreadystatechange = function () {
//             if (http.readyState === 4 && http.status === 200) {
//                 var json = JSON.parse(http.responseText)
//                 //(http.responseText)
//                 if (
//                     dashboar_ref.state.branch_admin === 'true' ||
//                     dashboar_ref.state.branch_user === 'true'
//                 ) {
//                     if (json.status === 200) {
//                         //(json.branches)
//                         var branches = []
//                         var customer = []

//                         //('never here')
//                         json.branches.forEach((element) => {
//                             var temp = {
//                                 value: element.branch_name,
//                                 label: element.branch_name,
//                                 id: element.branch_id,
//                             }
//                             //(temp)
//                             branches.push(temp)
//                             // //(orgs)
//                         })

//                         //(orgs)
//                         if (branches) {
//                             branches.unshift({
//                                 value: 'all',
//                                 label: 'all',
//                                 id: 0,
//                             })
//                         }

//                         dashboar_ref.setState({
//                             options_branch: branches,
//                             loading: false,
//                             organization: {
//                                 value: 'all',
//                                 label: 'all',
//                                 id: -1,
//                             },
//                         })
//                     } else {
//                         dashboar_ref.setState({
//                             error_modal_open: true,
//                             message_title: 'Could not load data',
//                             message_body:
//                                 'Server did not respond in time. Try refreshing page or contact your service provider',
//                         })
//                     }
//                 } else {
//                     if (json.status === 200) {
//                         //(json.organisations)
//                         var orgs = []
//                         var customer = []

//                         //('never here')
//                         json.organisations &&
//                             json.organisations.forEach((element) => {
//                                 var temp = {
//                                     value: element.org_name,
//                                     label: element.org_name,
//                                     id: element.org_id,
//                                 }
//                                 //(temp)
//                                 orgs.push(temp)
//                                 //(orgs)
//                             })

//                         //(orgs)
//                         if (orgs) {
//                             orgs.unshift({
//                                 value: 'all',
//                                 label: 'all',
//                                 id: 0,
//                             })
//                         }
//                         //(orgs)

//                         dashboar_ref.setState(
//                             {
//                                 options_organization: orgs,
//                                 loading: false,
//                                 options_customers: customer,
//                             },
//                             function () {
//                                 //(dashboar_ref.state.options_organization)
//                             }
//                         )
//                     } else {
//                         dashboar_ref.setState({
//                             error_modal_open: true,
//                             message_title: 'Could not load data',
//                             message_body:
//                                 'Server did not respond in time. Try refreshing page or contact your service provider',
//                         })
//                     }
//                 }
//             }
//             if (http.readyState === 4 && http.status === 401) {
//                 logout()
//             }
//         }
//         http.onerror = function () {
//             dashboar_ref.setState({
//                 error_modal_open: true,
//                 message_title: 'Could not load data',
//                 message_body:
//                     'Server did not respond in time. Try refreshing page or contact your service provider',
//             })
//         }
//     }

//     handleOrganizationSelect = (organization) => {
//         this.setState({ organization })
//         if (organization.id !== 0) {
//             this.setState({ loading: true })
//             const cookies = new Cookies()
//             var http = new XMLHttpRequest()
//             var dashboar_ref = this
//             var user_id = cookies.get('user_id')
//             var token = cookies.get('token')
//             http.open(
//                 'GET',
//                 url +
//                     '/api/questions/wizard/branch?user_id=' +
//                     user_id +
//                     '&org_id=' +
//                     organization.id,
//                 true
//             )
//             http.setRequestHeader('Authorization', 'Token ' + token)
//             http.send()
//             http.onreadystatechange = function () {
//                 //(http.responseText)
//                 if (http.readyState === 4 && http.status === 200) {
//                     var json = JSON.parse(http.responseText)
//                     if (json.status === 200) {
//                         var branches = []
//                         json.branches.forEach((element) => {
//                             var temp = {
//                                 value: element.branch_name,
//                                 label: element.branch_name,
//                                 id: element.branch_id,
//                             }
//                             branches.push(temp)
//                             //(branches)
//                         })
//                         branches.unshift({
//                             value: 'all',
//                             label: 'all',
//                             id: 0,
//                         })
//                         dashboar_ref.setState(
//                             {
//                                 options_branch: branches,
//                                 loading: false,
//                             },
//                             this.enable_btn
//                         )
//                     } else {
//                         dashboar_ref.setState({
//                             error_modal_open: true,
//                             message_title: 'Could not load data',
//                             message_body:
//                                 'Server did not respond in time. Try refreshing page or contact your service provider',
//                         })
//                     }
//                 }
//             }
//             http.onerror = function () {
//                 dashboar_ref.setState({
//                     error_modal_open: true,
//                     message_title: 'Could not load data',
//                     message_body:
//                         'Server did not respond in time. Try refreshing page or contact your service provider',
//                 })
//             }

//             //(`Option selected:`, organization.id);
//         } else {
//             var branches = []
//             branches.push({
//                 value: 'all',
//                 label: 'all',
//                 id: 0,
//             })
//             this.setState(
//                 {
//                     options_branch: branches,
//                     branch: { value: 'all', label: 'all', id: 0 },
//                     loading: false,
//                 },
//                 this.enable_btn
//             )
//         }
//     }
//     handleBranchSelectSelect = (branch) => {
//         this.setState({ branch }, this.enable_btn)

//         //(`Option selected:`, branch);
//     }

//     handleCustomerSelect = (customer) => {
//         var input = document.getElementById('cust_code').value
//         if (input !== '') {
//             //("in "+input)
//             this.setState({ customer: input })
//             //(this.state.customer)
//         } else {
//             //("in "+input)
//             this.setState({ customer: input })
//             //(this.state.customer)
//         }
//     }
//     enable_btn = () => {
//         if ((organization !== null) & (branch !== null)) {
//             this.setState({
//                 fetch_btn_disabled: false,
//             })
//         } else {
//             this.setState({
//                 fetch_btn_disabled: true,
//             })
//         }
//     }

//     fetch = () => {
//         this.setState({ loading: true })
//         //(pageSize)
//         //('fetching now')
//         const cookies = new Cookies()
//         var http = new XMLHttpRequest()
//         var dashboar_ref = this
//         var user_id = cookies.get('user_id')
//         var token = cookies.get('token')
//         //(user_id)
//         //(organization.id)
//         //(branch.id)
//         //(this.state.customer.id)
//         var local_url =
//             url +
//             '/api/questions?user_id=' +
//             user_id +
//             '&org_id=' +
//             organization.id +
//             '&branch_id=' +
//             branch.id +
//             '&customer_code=' +
//             this.state.customer +
//             '&page=' +
//             activePage +
//             '&page_size=' +
//             pageSize
//         //(url)
//         http.open('GET', local_url, true)
//         http.setRequestHeader('Authorization', 'Token ' + token)
//         http.send()
//         http.onreadystatechange = function () {
//             //(http.responseText)
//             if (http.readyState === 4 && http.status === 200) {
//                 //("this guilty"+http.responseText)
//                 var json = JSON.parse(http.responseText)
//                 if (json.status === 200) {
//                     //(json.view_questions)
//                     var question = []
//                     json.view_questions.forEach((element) => {
//                         question.push(element)
//                     })
//                     //("count "+json.total_questions)
//                     dashboar_ref.setState({
//                         questions: question,
//                         total_records: json.total_questions,
//                         tableHidden: false,
//                         loading: false,
//                         activePage: 1,
//                         tableLoading: false,
//                         activePage: dashboar_ref.state.activePage,
//                     })
//                 } else {
//                     dashboar_ref.setState({
//                         error_modal_open: true,
//                         message_title: 'Could not load data',
//                         message_body:
//                             'Server did not respond in time. Try refreshing page or contact your service provider',
//                     })
//                 }
//             }
//         }
//         http.onerror = function () {
//             dashboar_ref.setState({
//                 error_modal_open: true,
//                 message_title: 'Could not load data',
//                 message_body:
//                     'Server did not respond in time. Try refreshing page or contact your service provider',
//             })
//         }
//     }

//     fetch_with_page_size = (pageSize) => {
//         this.setState({ tableLoading: true })
//         //(pageSize)
//         //('fetching now')
//         const cookies = new Cookies()
//         var http = new XMLHttpRequest()
//         var dashboar_ref = this
//         var user_id = cookies.get('user_id')
//         var token = cookies.get('token')
//         //(user_id)
//         //(organization.id)
//         //(branch.id)
//         //(this.state.customer.id)
//         var local_url =
//             url +
//             '/api/questions?user_id=' +
//             user_id +
//             '&org_id=' +
//             organization.id +
//             '&branch_id=' +
//             branch.id +
//             '&customer_code=' +
//             this.state.customer +
//             '&page=' +
//             1 +
//             '&page_size=' +
//             pageSize
//         //(url)
//         http.open('GET', local_url, true)
//         http.setRequestHeader('Authorization', 'Token ' + token)
//         http.send()
//         http.onreadystatechange = function () {
//             //(http.responseText)
//             if (http.readyState === 4 && http.status === 200) {
//                 //("this guilty"+http.responseText)
//                 var json = JSON.parse(http.responseText)
//                 if (json.status === 200) {
//                     //(json.view_questions)
//                     var question = []
//                     json.view_questions.forEach((element) => {
//                         question.push(element)
//                     })
//                     //("count "+json.total_questions)
//                     dashboar_ref.setState({
//                         questions: question,
//                         total_records: json.total_questions,
//                         tableHidden: false,
//                         loading: false,
//                         activePage: 1,
//                         tableLoading: false,
//                     })
//                 } else {
//                     dashboar_ref.setState({
//                         error_modal_open: true,
//                         message_title: 'Could not load data',
//                         message_body:
//                             'Server did not respond in time. Try refreshing page or contact your service provider',
//                     })
//                 }
//             }
//         }
//         http.onerror = function () {
//             dashboar_ref.setState({
//                 error_modal_open: true,
//                 message_title: 'Could not load data',
//                 message_body:
//                     'Server did not respond in time. Try refreshing page or contact your service provider',
//             })
//         }
//     }

//     handlePageSizeChange = (pageSize) => {
//         //("adjusting")
//         this.setState(
//             { page_size: pageSize },
//             fetchQuestions_with_page_size(pageSize)
//         )
//     }

//     next_page = (page) => {
//         this.setState({ tableLoading: true })
//         const cookies = new Cookies()
//         var http = new XMLHttpRequest()
//         var dashboar_ref = this
//         var user_id = cookies.get('user_id')
//         var token = cookies.get('token')
//         //(user_id)
//         //(organization.id)
//         //(branch.id)
//         //(this.state.customer.id)
//         var local_url =
//             url +
//             '/api/questions?user_id=' +
//             user_id +
//             '&org_id=' +
//             organization.id +
//             '&branch_id=' +
//             branch.id +
//             '&customer_code=' +
//             this.state.customer +
//             '&page=' +
//             page +
//             '&page_size=' +
//             pageSize
//         //(local_url)
//         http.open('GET', local_url, true)
//         http.setRequestHeader('Authorization', 'Token ' + token)
//         http.send()
//         http.onreadystatechange = function () {
//             //(http.responseText)
//             if (http.readyState === 4 && http.status === 200) {
//                 var json = JSON.parse(http.responseText)
//                 if (json.status === 200) {
//                     dashboar_ref.setState({ questions: [] })
//                     //(json.view_questions)
//                     var question = []
//                     json.view_questions.forEach((element) => {
//                         question.push(element)
//                     })
//                     //("count "+json.total_questions)
//                     dashboar_ref.setState({
//                         questions: question,
//                         total_records: json.total_questions,
//                         tableHidden: false,
//                         tableLoading: false,
//                         activePage: page,
//                         loading: false,
//                     })
//                 } else {
//                     dashboar_ref.setState({
//                         error_modal_open: true,
//                         message_title: 'Could not load data',
//                         message_body:
//                             'Server did not respond in time. Try refreshing page or contact your service provider',
//                     })
//                 }
//             }
//         }
//         http.onerror = function () {
//             dashboar_ref.setState({
//                 error_modal_open: true,
//                 message_title: 'Could not load data',
//                 message_body:
//                     'Server did not respond in time. Try refreshing page or contact your service provider',
//             })
//         }
//     }

//     create_question_click_handle = () => {
//         window.location = '/create-question'
//     }

//     close_error_model = () => {
//         this.setState({
//             error_modal_open: false,
//             loading: false,
//             tableLoading: false,
//         })
//     }

//     render() {
//         if (branch_admin === 'true') {
//             return (
//                 <div>
//                     <div>
//                         <Modal isOpen={errorModalOpen}>
//                             <ModalHeader>
//                                 <h3>{messageTitle}</h3>
//                             </ModalHeader>
//                             <ModalBody>
//                                 <h6>{messageBody}</h6>
//                             </ModalBody>
//                             <ModalFooter>
//                                 <Button
//                                     color="primary"
//                                     onClick={closeErrorModal}
//                                 >
//                                     Close
//                                 </Button>
//                             </ModalFooter>
//                         </Modal>
//                     </div>

//                     <Loader loading={loading} fullPage={true} />
//                     <div className="clearfix" id="page-header">
//                         <div>
//                             <Header />
//                         </div>
//                     </div>
//                     <div>
//                         <SideBar isActive="questions" />
//                     </div>
//                     <div id="page-content-wrapper" className="rm-transition">
//                         <div id="page-content">
//                             <div className="row">
//                                 <div className="col-md-4">
//                                     <button
//                                         class="btn btn-blue-alt fetch_questions"
//                                         id="btn"
//                                         style={{ margin: 0, width: 150 }}
//                                         onClick={
//                                             createQuestionClickHandle
//                                         }
//                                     >
//                                         <i
//                                             class="fa fa-plus"
//                                             style={{ marginRight: 5 }}
//                                         ></i>
//                                         <b>Create Questions</b>
//                                     </button>
//                                 </div>
//                                 <div className="col-md-4">
//
//                                     <h3>Questions</h3>
//                                 </div>
//                                 <div className="col-md-4"></div>
//                             </div>
//                             <div className="row" style={{ paddingTop: 30 }}>
//                                 <div className="col-md-4">
//                                     <h3>Select Branch</h3>
//                                     <SelectList
//                                         options={optionsBranch}
//                                         actionHandler={
//                                             handleBranchSelect
//                                         }
//                                         selectedOption={branch}
//                                     />
//                                 </div>
//                                 <div className="col-md-4">
//                                     <h3>Customer Code</h3>
//                                     <input
//                                         class="form-control"
//                                         placeholder="Customer_Code,Customer_Code,Customer_code"
//                                         id="cust_code"
//                                         onBlur={handleCustomerSelect}
//                                     ></input>
//                                 </div>
//                                 <div className="col-md-3">
//                                     <button
//                                         class="btn btn-blue-alt fetch_questions"
//                                         id="btn"
//                                         onClick={fetchQuestions}
//                                         disabled={fetchBtnDisabled}
//                                     >
//                                         <b>Fetch Questions</b>
//                                     </button>
//                                 </div>
//                             </div>
//                             <div
//                                 className="container"
//                                 style={{ marginTop: 140 }}
//                                 hidden={tableHidden}
//                             >
//                                 <Loader loading={tableLoading} />
//                                 <ReactCSSTransitionGroup
//                                     transitionName="example"
//                                     transitionEnterTimeout={5000}
//                                     transitionLeaveTimeout={3000}
//                                 >
//                                     <QuestionTable
//                                         data={questions}
//                                         record={totalRecords}
//                                         fetch={nextPage}
//                                         activePage={activePage}
//                                         orgs={optionsOrganization}
//                                         branches={optionsBranch}
//                                         section={1}
//                                         refresh={fetchQuestions}
//                                     />
//                                 </ReactCSSTransitionGroup>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )
//         }
//         if (branch_user === 'true') {
//             return (
//                 <div>
//                     <div>
//                         <Modal isOpen={errorModalOpen}>
//                             <ModalHeader>
//                                 <h3>{messageTitle}</h3>
//                             </ModalHeader>
//                             <ModalBody>
//                                 <h6>{messageBody}</h6>
//                             </ModalBody>
//                             <ModalFooter>
//                                 <Button
//                                     color="primary"
//                                     onClick={closeErrorModal}
//                                 >
//                                     Close
//                                 </Button>
//                             </ModalFooter>
//                         </Modal>
//                     </div>

//                     <Loader loading={loading} fullPage={true} />
//                     <div className="clearfix" id="page-header">
//                         <div>
//                             <Header />
//                         </div>
//                     </div>
//                     <div>
//                         <SideBar isActive="questions" />
//                     </div>
//                     <div id="page-content-wrapper" className="rm-transition">
//                         <div id="page-content">
//                             <div className="row">
//                                 <div className="col-md-4"></div>
//                                 <div className="col-md-4">
//
//                                     <h3>Questions</h3>
//                                 </div>
//                                 <div className="col-md-4"></div>
//                             </div>
//                             <div className="row" style={{ paddingTop: 30 }}>
//                                 <div className="col-md-4">
//                                     <h3>Select Branch</h3>
//                                     <SelectList
//                                         options={optionsBranch}
//                                         actionHandler={
//                                             handleBranchSelect
//                                         }
//                                         selectedOption={branch}
//                                     />
//                                 </div>
//                                 <div className="col-md-4">
//                                     <h3>Customer Code</h3>
//                                     <input
//                                         class="form-control"
//                                         placeholder="Customer_Code,Customer_Code,Customer_code"
//                                         id="cust_code"
//                                         onBlur={handleCustomerSelect}
//                                     ></input>
//                                 </div>
//                                 <div className="col-md-3">
//                                     <button
//                                         class="btn btn-blue-alt fetch_questions"
//                                         id="btn"
//                                         onClick={fetchQuestions}
//                                         disabled={fetchBtnDisabled}
//                                     >
//                                         <b>Fetch Questions</b>
//                                     </button>
//                                 </div>
//                             </div>
//                             <div
//                                 className="container"
//                                 style={{ marginTop: 140 }}
//                                 hidden={tableHidden}
//                             >
//                                 <Loader loading={tableLoading} />
//                                 <ReactCSSTransitionGroup
//                                     transitionName="example"
//                                     transitionEnterTimeout={5000}
//                                     transitionLeaveTimeout={3000}
//                                 >
//                                     <QuestionTable
//                                         data={questions}
//                                         record={totalRecords}
//                                         fetch={nextPage}
//                                         activePage={activePage}
//                                         orgs={optionsOrganization}
//                                         branches={optionsBranch}
//                                         section={1}
//                                         refresh={fetchQuestions}
//                                         hideCTA={true}
//                                     />
//                                 </ReactCSSTransitionGroup>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )
//         } else {
//             return (
//                 <div>
//                     <div>
//                         <Modal isOpen={errorModalOpen}>
//                             <ModalHeader>
//                                 {messageTitle}
//                             </ModalHeader>
//                             <ModalBody>
//                                 <h6>{messageBody}</h6>
//                             </ModalBody>
//                             <ModalFooter>
//                                 <Button
//                                     color="primary"
//                                     onClick={closeErrorModal}
//                                 >
//                                     Close
//                                 </Button>
//                             </ModalFooter>
//                         </Modal>
//                     </div>

//                     <Loader loading={loading} fullPage={true} />
//                     <div className="clearfix" id="page-header">
//                         <div>
//                             <Header />
//                         </div>
//                     </div>
//                     <div>
//                         <SideBar isActive="questions" />
//                     </div>
//                     <div id="page-content-wrapper" className="rm-transition">
//                         <div id="page-content">
//                             <div className="row">
//                                 <div className="col-md-4">
//                                     <button
//                                         class="btn btn-blue-alt fetch_questions"
//                                         id="btn"
//                                         style={{ margin: 0, width: 150 }}
//                                         onClick={
//                                             createQuestionClickHandle
//                                         }
//                                     >
//                                         <i
//                                             class="fa fa-plus"
//                                             style={{ marginRight: 5 }}
//                                         ></i>
//                                         <b>Create Questions</b>
//                                     </button>
//                                 </div>
//                                 <div className="col-md-4">
//
//                                     <h3>Questions</h3>
//                                 </div>
//                                 <div className="col-md-4"></div>
//                             </div>
//                             <div className="row" style={{ paddingTop: 30 }}>
//                                 <div className="col-md-3">
//                                     <h3>Select Organization</h3>
//                                     <SelectList
//                                         options={
//                                             optionsOrganization
//                                         }
//                                         actionHandler={
//                                             this.handleOrganizationSelect
//                                         }
//                                         selectedOption={organization}
//                                     />
//                                 </div>
//                                 <div className="col-md-3">
//                                     <h3>Select Branch</h3>
//                                     <SelectList
//                                         options={optionsBranch}
//                                         actionHandler={
//                                             handleBranchSelect
//                                         }
//                                         selectedOption={branch}
//                                     />
//                                 </div>
//                                 <div className="col-md-3">
//                                     <h3>Customer Code</h3>
//                                     <input
//                                         class="form-control"
//                                         placeholder="Customer_Code,Customer_Code,Customer_code"
//                                         id="cust_code"
//                                         onBlur={handleCustomerSelect}
//                                     ></input>
//                                 </div>
//                                 <div className="col-md-3 ">
//                                     <button
//                                         class="btn btn-blue-alt fetch_questions"
//                                         id="btn"
//                                         onClick={fetchQuestions}
//                                         disabled={fetchBtnDisabled}
//                                     >
//                                         <b>Fetch Questions</b>
//                                     </button>
//                                 </div>
//                             </div>
//                             <div
//                                 className="container"
//                                 style={{ marginTop: 140 }}
//                                 hidden={tableHidden}
//                             >
//                                 <Loader loading={tableLoading} />
//                                 <ReactCSSTransitionGroup
//                                     transitionName="example"
//                                     transitionEnterTimeout={5000}
//                                     transitionLeaveTimeout={3000}
//                                 >
//                                     <QuestionTable
//                                         data={questions}
//                                         record={totalRecords}
//                                         fetch={nextPage}
//                                         activePage={activePage}
//                                         orgs={optionsOrganization}
//                                         branches={optionsBranch}
//                                         refresh={fetchQuestions}
//                                         page_size={pageSize}
//                                         handlePageSizeChange={
//                                             handlePageSizeChange
//                                         }
//                                     />
//                                 </ReactCSSTransitionGroup>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )
//         }
//     }
// }

// export default Questions

import React from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import { Loader } from 'react-overlay-loader'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import Cookies from 'universal-cookie'
import SelectList from '../components/createQuestionSubComponents/dropdownSelect'
import Header from '../components/dashboardSubComponents/header'
import SideBar from '../components/dashboardSubComponents/sideBarNav'
import { logout, url } from '../components/helper'
import QuestionTable from '../components/questionListSubComponents/questionTable'

const Questions = () => {
    const [superuser, setSuperuser] = React.useState('')
    const [organizationAdmin, setOrganizationAdmin] = React.useState('')
    const [branchAdmin, setBranchAdmin] = React.useState('')
    const [branchUser, setBranchUser] = React.useState('')
    const [currentSection, setCurrentSection] = React.useState(1)
    const [optionsOrganization, setOptionsOrganization] = React.useState([])
    const [optionsBranch, setOptionsBranch] = React.useState([])
    const [optionsCustomers, setOptionsCustomers] = React.useState('')
    const [optionsSections, setOptionsSections] = React.useState([])
    const [totalRecords, setTotalRecords] = React.useState(0)
    const [questions, setQuestions] = React.useState([])
    const [organization, setOrganization] = React.useState(null)
    const [branch, setBranch] = React.useState(null)
    const [customer, setCustomer] = React.useState('')
    const [loading, setLoading] = React.useState(true)
    const [tableHidden, setTableHidden] = React.useState(true)
    const [tableLoading, setTableLoading] = React.useState(false)
    const [activePage, setActivePage] = React.useState(1)
    const [messageTitle, setMessageTitle] = React.useState('')
    const [messageBody, setMessageBody] = React.useState('')
    const [errorModalOpen, setErrorModalOpen] = React.useState(false)
    const [fetchBtnDisabled, setFetchBtnDisabled] = React.useState(true)
    const [pageSize, setPageSize] = React.useState(20)

    //Check credential based on cookies, set all the credential states
    const credentialCheck = () => {
        const cookies = new Cookies()

        const token = cookies.get('token')
        if (!token) {
            window.location = '/login'
        }
        setCurrentSection(1)

        const superuser = cookies.get('superuser')
        const organizationAdmin = cookies.get('organizationAdmin')
        const branchAdmin = cookies.get('branch-admin')
        const branchUser = cookies.get('branch-user')
        // console.log('BRANCH ADMIN 1', branchAdmin)
        setSuperuser(superuser)
        setOrganizationAdmin(organizationAdmin)
        setBranchAdmin(branchAdmin)
        setBranchUser(branchUser)
    }

    //Get the information regarding the wizard to be added
    const getWizard = async () => {
        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')

        const branchAdmin = cookies.get('branch-admin')

        let wizardPath = ''

        if (branchAdmin === 'true') {
            wizardPath = `${url}/api/questions/wizard/branch?user_id=${userId}`
        } else {
            wizardPath = `${url}/api/questions/wizard/organisation?user_id=${userId}`
        }

        const options = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }

        try {
            const res = await fetch(wizardPath, options)
            const data = await res.json()
            switch (data.status) {
                case 200:
                    //Managed Branch Admin and User
                    if (branchAdmin === 'true' || branchUser === 'true') {
                        let branches = []
                        let customer = []
                        data.branches.forEach((br) => {
                            const detail = {
                                value: br.branch_name,
                                label: br.branch_name,
                                id: br.branch_id,
                            }
                            branches.push(detail)
                        })

                        if (branches) {
                            branches.unshift({
                                value: 'all',
                                label: 'all',
                                id: 0,
                            })
                        }

                        setOptionsBranch(branches)
                        setLoading(false)
                        setOrganization({ value: 'all', label: 'all', id: -1 })
                        break
                    }

                    if (branchAdmin !== 'true' && branchUser !== 'true') {
                        //Manage Organization
                        let orgs = []
                        let customer = []
                        data.organisations.forEach((org) => {
                            const detail = {
                                value: org.org_name,
                                label: org.org_name,
                                id: org.org_id,
                            }
                            orgs.push(detail)
                        })

                        if (orgs) {
                            orgs.unshift({
                                value: 'all',
                                label: 'all',
                                id: 0,
                            })
                        }

                        setOptionsOrganization(orgs)
                        setLoading(false)
                        setOptionsCustomers(customer)
                        break
                    }

                case 401:
                    logout()
                    break
                default:
                    console.error('Invalid data:', data)
                    setErrorModalOpen(true)
                    setMessageTitle('Could not load data')
                    setMessageBody(
                        'Server did not respond in time. Try refreshing page or contact your service provider'
                    )
                    break
            }
        } catch (err) {
            setErrorModalOpen(true)
            setMessageTitle('Could not load data')
            setMessageBody(
                'Server did not respond in time. Try refreshing page or contact your service provider'
            )
            console.error('Error', err)
        }
    }

    //Runs once on initial render
    React.useEffect(() => {
        credentialCheck()
        getWizard()
    }, [])

    //Gets branches as per selected organisation
    const handleOrganizationSelect = async (organization) => {
        setOrganization(organization)
        setBranch(null)
        if (organization.id === 0) {
            let branches = []
            branches.push({
                value: 'all',
                label: 'all',
                id: 0,
            })
            setOptionsBranch(branches)
            setBranch({ value: 'all', label: 'all', id: 0 })
            setLoading(false)
            return
        }
        setLoading(true)
        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')

        const options = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }

        try {
            const res = await fetch(
                `${url}/api/questions/wizard/branch?user_id=${userId}&org_id=${organization.id}`,
                options
            )
            const data = await res.json()
            switch (data.status) {
                case 200:
                    let branches = []
                    data.branches.forEach((br) => {
                        const detail = {
                            value: br.branch_name,
                            label: br.branch_name,
                            id: br.branch_id,
                        }
                        branches.push(detail)
                    })
                    branches.unshift({
                        value: 'all',
                        label: 'all',
                        id: 0,
                    })
                    setOptionsBranch(branches)
                    setLoading(false)

                    break
                default:
                    alert(1)
                    console.error('Invalid data', data)
                    setErrorModalOpen(true)
                    setMessageTitle('Could not load data')
                    setMessageBody(
                        'Server did not respond in time. Try refreshing page or contact your service provider'
                    )
                    break
            }
        } catch (err) {
            console.error('Error', err)
            setErrorModalOpen(true)
            setMessageTitle('Could not load data')
            setMessageBody(
                'Server did not respond in time. Try refreshing page or contact your service provider'
            )
        }
    }

    //Set the branch and enable the "next" button
    const handleBranchSelect = (branch) => {
        setBranch(branch)
    }

    //Get the customer code
    const handleCustomerSelect = () => {
        const input = document.getElementById('cust_code').value
        setCustomer(input)
    }

    //Originally called "fetch"
    //Fetches the question of a particular branch of a particular organisation
    const fetchQuestions = async () => {
        setLoading(true)
        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')
        const local_url = `${url}/api/questions?user_id=${userId}&org_id=${organization.id}&branch_id=${branch.id}&customer_code=${customer}&page=${activePage}&page_size=${pageSize}`

        const options = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }

        try {
            const res = await fetch(local_url, options)
            const data = await res.json()

            switch (data.status) {
                case 200:
                    setQuestions(data.view_questions)
                    setTotalRecords(data.total_questions)
                    setTableHidden(false)
                    setLoading(false)
                    setActivePage(1)
                    setTableLoading(false)
                    break
                default:
                    console.error('Invalid data', data)
                    setErrorModalOpen(true)
                    setMessageTitle('Could not load data')
                    setMessageBody(
                        'Server did not respond in time. Try refreshing page or contact your service provider'
                    )
                    break
            }
        } catch (err) {
            console.error('Error', err)
            setErrorModalOpen(true)
            setMessageTitle('Could not load data')
            setMessageBody(
                'Server did not respond in time. Try refreshing page or contact your service provider'
            )
        }
    }

    //Gets the next page of questions
    const nextPage = async (page) => {
        setTableLoading(true)
        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')
        const local_url = `${url}/api/questions?user_id=${userId}&org_id=${organization.id}&branch_id=${branch.id}&customer_code=${customer}&page=${page}&page_size=${pageSize}`

        const options = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
        try {
            const res = await fetch(local_url, options)
            const data = await res.json()

            switch (data.status) {
                case 200:
                    setQuestions(data.view_questions)
                    setTotalRecords(data.total_questions)
                    setTableHidden(false)
                    setLoading(false)
                    setActivePage(1)
                    setTableLoading(false)
                    break
                default:
                    console.error('Invalid data', data)
                    setErrorModalOpen(true)
                    setMessageTitle('Could not load data')
                    setMessageBody(
                        'Server did not respond in time. Try refreshing page or contact your service provider'
                    )
                    break
            }
        } catch (err) {
            console.error('Error', err)
            setErrorModalOpen(true)
            setMessageTitle('Could not load data')
            setMessageBody(
                'Server did not respond in time. Try refreshing page or contact your service provider'
            )
        }
    }

    //Why does this exist?!
    //Get the page... with size?
    const fetchWithPageSize = async () => {
        setTableLoading(true)
        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')
        const local_url = `${url}/api/questions?user_id=${userId}&org_id=${organization.id}&branch_id=${branch.id}&customer_code=${customer}&page=1&page_size=${pageSize}`

        const options = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
        try {
            const res = await fetch(local_url, options)
            const data = await res.json()

            switch (data.status) {
                case 200:
                    setQuestions(data.view_questions)
                    setTotalRecords(data.total_questions)
                    setTableHidden(false)
                    setLoading(false)
                    setActivePage(1)
                    setTableLoading(false)
                    break
                default:
                    console.error('Invalid data', data)
                    setErrorModalOpen(true)
                    setMessageTitle('Could not load data')
                    setMessageBody(
                        'Server did not respond in time. Try refreshing page or contact your service provider'
                    )
                    break
            }
        } catch (err) {
            console.error('Error', err)
            setErrorModalOpen(true)
            setMessageTitle('Could not load data')
            setMessageBody(
                'Server did not respond in time. Try refreshing page or contact your service provider'
            )
        }
    }

    //Navigate to create question page
    const createQuestionClickHandle = () => {
        window.location = '/create-question'
    }

    //Handle closing any error modal popup
    const closeErrorModal = () => {
        setErrorModalOpen(false)
        setLoading(false)
        setTableLoading(false)
    }

    React.useEffect(() => {
        enableBtn()
    }, [organization, branch])

    //Enable the button to be enabled
    //PFIX: Might need rejigging
    const enableBtn = () => {
        // console.log('RUNING', !organization && branch === null)
        // console.log('organization', organization)
        // console.log('branch', branch)

        setFetchBtnDisabled(!organization || !branch)
    }

    //Tbh, anything page size I have yet to fully understand
    const handlePageSizeChange = (pageSize) => {
        setPageSize(pageSize)
        fetchWithPageSize(pageSize)
    }

    return (
        <div>
            {branchAdmin === 'true' ? (
                <div>
                    <div>
                        <Modal isOpen={errorModalOpen}>
                            <ModalHeader>
                                <h3>{messageTitle}</h3>
                            </ModalHeader>
                            <ModalBody>
                                <h6>{messageBody}</h6>
                            </ModalBody>
                            <ModalFooter>
                                <Button
                                    color="primary"
                                    onClick={closeErrorModal}
                                >
                                    Close
                                </Button>
                            </ModalFooter>
                        </Modal>
                    </div>

                    <Loader loading={loading} fullPage={true} />
                    <div className="clearfix" id="page-header">
                        <div>
                            <Header />
                        </div>
                    </div>
                    <div>
                        <SideBar isActive="questions" />
                    </div>
                    <div id="page-content-wrapper" className="rm-transition">
                        <div id="page-content">
                            <div className="row">
                                <div className="col-md-4">
                                    <button
                                        class="btn btn-blue-alt fetch_questions"
                                        id="btn"
                                        style={{ margin: 0, width: 150 }}
                                        onClick={createQuestionClickHandle}
                                    >
                                        <i
                                            class="fa fa-plus"
                                            style={{ marginRight: 5 }}
                                        ></i>
                                        <b>Create Questions</b>
                                    </button>
                                </div>
                                <div className="col-md-4">
                                    <h3>Questions</h3>
                                </div>
                                <div className="col-md-4"></div>
                            </div>
                            <div className="row" style={{ paddingTop: 30 }}>
                                <div className="col-md-4">
                                    <h3>Select Branch</h3>
                                    <SelectList
                                        options={optionsBranch}
                                        actionHandler={handleBranchSelect}
                                        selectedOption={branch}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <h3>Customer Code</h3>
                                    <input
                                        class="form-control"
                                        placeholder="Customer_Code,Customer_Code,Customer_code"
                                        id="cust_code"
                                        onBlur={handleCustomerSelect}
                                    ></input>
                                </div>
                                <div className="col-md-3">
                                    <button
                                        class="btn btn-blue-alt fetch_questions"
                                        id="btn"
                                        onClick={fetchQuestions}
                                        disabled={fetchBtnDisabled}
                                    >
                                        <b>Fetch Questions</b>
                                    </button>
                                </div>
                            </div>
                            <div
                                className="container"
                                style={{ marginTop: 140 }}
                                hidden={tableHidden}
                            >
                                <Loader loading={tableLoading} />
                                <ReactCSSTransitionGroup
                                    transitionName="example"
                                    transitionEnterTimeout={5000}
                                    transitionLeaveTimeout={3000}
                                >
                                    <QuestionTable
                                        data={questions}
                                        record={totalRecords}
                                        fetch={nextPage}
                                        activePage={activePage}
                                        orgs={optionsOrganization}
                                        branches={optionsBranch}
                                        section={1}
                                        refresh={fetchQuestions}
                                    />
                                </ReactCSSTransitionGroup>
                            </div>
                        </div>
                    </div>
                </div>
            ) : branchUser === 'true' ? (
                <div>
                    <div>
                        <Modal isOpen={errorModalOpen}>
                            <ModalHeader>
                                <h3>{messageTitle}</h3>
                            </ModalHeader>
                            <ModalBody>
                                <h6>{messageBody}</h6>
                            </ModalBody>
                            <ModalFooter>
                                <Button
                                    color="primary"
                                    onClick={closeErrorModal}
                                >
                                    Close
                                </Button>
                            </ModalFooter>
                        </Modal>
                    </div>

                    <Loader loading={loading} fullPage={true} />
                    <div className="clearfix" id="page-header">
                        <div>
                            <Header />
                        </div>
                    </div>
                    <div>
                        <SideBar isActive="questions" />
                    </div>
                    <div id="page-content-wrapper" className="rm-transition">
                        <div id="page-content">
                            <div className="row">
                                <div className="col-md-4"></div>
                                <div className="col-md-4">
                                    <h3>Questions</h3>
                                </div>
                                <div className="col-md-4"></div>
                            </div>
                            <div className="row" style={{ paddingTop: 30 }}>
                                <div className="col-md-4">
                                    <h3>Select Branch</h3>
                                    <SelectList
                                        options={optionsBranch}
                                        actionHandler={handleBranchSelect}
                                        selectedOption={branch}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <h3>Customer Code</h3>
                                    <input
                                        class="form-control"
                                        placeholder="Customer_Code,Customer_Code,Customer_code"
                                        id="cust_code"
                                        onBlur={handleCustomerSelect}
                                    ></input>
                                </div>
                                <div className="col-md-3">
                                    <button
                                        class="btn btn-blue-alt fetch_questions"
                                        id="btn"
                                        onClick={fetchQuestions}
                                        disabled={fetchBtnDisabled}
                                    >
                                        <b>Fetch Questions</b>
                                    </button>
                                </div>
                            </div>
                            <div
                                className="container"
                                style={{ marginTop: 140 }}
                                hidden={tableHidden}
                            >
                                <Loader loading={tableLoading} />
                                <ReactCSSTransitionGroup
                                    transitionName="example"
                                    transitionEnterTimeout={5000}
                                    transitionLeaveTimeout={3000}
                                >
                                    <QuestionTable
                                        data={questions}
                                        record={totalRecords}
                                        fetch={nextPage}
                                        activePage={activePage}
                                        orgs={optionsOrganization}
                                        branches={optionsBranch}
                                        section={1}
                                        refresh={fetchQuestions}
                                        hideCTA={true}
                                    />
                                </ReactCSSTransitionGroup>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div>
                    <div>
                        <Modal isOpen={errorModalOpen}>
                            <ModalHeader>{messageTitle}</ModalHeader>
                            <ModalBody>
                                <h6>{messageBody}</h6>
                            </ModalBody>
                            <ModalFooter>
                                <Button
                                    color="primary"
                                    onClick={closeErrorModal}
                                >
                                    Close
                                </Button>
                            </ModalFooter>
                        </Modal>
                    </div>

                    <Loader loading={loading} fullPage={true} />
                    <div className="clearfix" id="page-header">
                        <div>
                            <Header />
                        </div>
                    </div>
                    <div>
                        <SideBar isActive="questions" />
                    </div>
                    <div id="page-content-wrapper" className="rm-transition">
                        <div id="page-content">
                            <div className="row">
                                <div className="col-md-4">
                                    <button
                                        class="btn btn-blue-alt fetch_questions"
                                        id="btn"
                                        style={{ margin: 0, width: 150 }}
                                        onClick={createQuestionClickHandle}
                                    >
                                        <i
                                            class="fa fa-plus"
                                            style={{ marginRight: 5 }}
                                        ></i>
                                        <b>Create Questions</b>
                                    </button>
                                </div>
                                <div className="col-md-4">
                                    <h3>Questions</h3>
                                </div>
                                <div className="col-md-4"></div>
                            </div>
                            <div className="row" style={{ paddingTop: 30 }}>
                                <div className="col-md-3">
                                    <h3>Select Organization</h3>
                                    <SelectList
                                        options={optionsOrganization}
                                        actionHandler={handleOrganizationSelect}
                                        selectedOption={organization}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <h3>Select Branch</h3>
                                    <SelectList
                                        options={optionsBranch}
                                        actionHandler={handleBranchSelect}
                                        selectedOption={branch}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <h3>Customer Code</h3>
                                    <input
                                        class="form-control"
                                        placeholder="Customer_Code,Customer_Code,Customer_code"
                                        id="cust_code"
                                        onBlur={handleCustomerSelect}
                                    ></input>
                                </div>
                                <div className="col-md-3 ">
                                    <button
                                        class="btn btn-blue-alt fetch_questions"
                                        id="btn"
                                        onClick={fetchQuestions}
                                        disabled={fetchBtnDisabled}
                                    >
                                        <b>Fetch Questions</b>
                                    </button>
                                </div>
                            </div>
                            <div
                                className="container"
                                style={{ marginTop: 140 }}
                                hidden={tableHidden}
                            >
                                <Loader loading={tableLoading} />
                                <ReactCSSTransitionGroup
                                    transitionName="example"
                                    transitionEnterTimeout={5000}
                                    transitionLeaveTimeout={3000}
                                >
                                    <QuestionTable
                                        data={questions}
                                        record={totalRecords}
                                        fetch={nextPage}
                                        activePage={activePage}
                                        orgs={optionsOrganization}
                                        branches={optionsBranch}
                                        refresh={fetchQuestions}
                                        page_size={pageSize}
                                        handlePageSizeChange={
                                            handlePageSizeChange
                                        }
                                    />
                                </ReactCSSTransitionGroup>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Questions

/**
 * Notes
 * - A lot of clashing name spaces (I.E handlePageSizeChange with pageSize)
 * - fetch function needs a rename or it will clash with api
 * - fetchWithPageSize is too similar to fetchQuestions and nextPage
 * - This goddamn page should be burned to the ground
 */



// WEBPACK FOOTER //
// src/Routes/Questions.js